import { render, staticRenderFns } from "./UploadLottieNonAdmin.vue?vue&type=template&id=f2cc12a4&"
import script from "./UploadLottieNonAdmin.vue?vue&type=script&lang=js&"
export * from "./UploadLottieNonAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports